import { Divider, Box } from '@cad-arc';
import { MapAssignedUnitInfo } from '@mark43/cad-api';
import { EventGeneralInfoBlock } from '../event-general-info-block';
import { getEventIcon } from '../helpers';
import { eventNotificationPriorityToColors } from '../../../../event-notifications/event-notifications';
import { CommonSize } from '../../../../common/helpers/utils';

type EventOverviewProps = {
    assignedUnits: MapAssignedUnitInfo[];
    priority?: string;
    priorityAttributeId?: number | null;
    agencyTypeGlobalAttrId?: number;
    agencyEventNumber?: string;
    cfsCode?: string;
    cfsDescription?: string;
    entityId: number;
    eventHasLocationNotification: boolean;
    size?: CommonSize;
};

export function EventOverview({
    assignedUnits,
    priority,
    priorityAttributeId,
    agencyTypeGlobalAttrId,
    agencyEventNumber,
    cfsCode,
    cfsDescription,
    entityId,
    eventHasLocationNotification,
    size,
}: EventOverviewProps): React.ReactElement {
    const blockBorderBottomColor = eventHasLocationNotification
        ? eventNotificationPriorityToColors['STANDARD'].notchOrText
        : 'transparent';

    const hasAssignedUnits = !!assignedUnits?.length;

    const eventIcon = getEventIcon(hasAssignedUnits, priorityAttributeId, agencyTypeGlobalAttrId);

    return (
        <Box
            data-testid="MAP_EVENT_OVERVIEW_SECTION"
            borderBottomWidth="2px"
            borderBottomColor={blockBorderBottomColor}
        >
            <Box padding="12px 18px">
                <EventGeneralInfoBlock
                    eventIcon={eventIcon}
                    eventPriority={priority}
                    agencyEventNumber={agencyEventNumber}
                    cfsCode={cfsCode}
                    cfsDescription={cfsDescription}
                    eventId={entityId}
                    isAssigned={hasAssignedUnits}
                    size={size}
                />
            </Box>
            {!eventHasLocationNotification && <Divider />}
        </Box>
    );
}
